import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../auth/services/auth.service';

@Component({
  selector: 'app-startup-loading-overlay',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (isStartupLoading()) {
      <div class="startup-overlay">
        <div class="startup-spinner-container">
          <div class="spinner"></div>
          <p class="startup-message">Loading application...</p>
        </div>
      </div>
    }
  `,
  styles: [
    `
      .startup-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(135deg, #0d4e6a 0%, #0f6b85 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        animation: fadeIn 0.3s ease-out;
      }

      @keyframes fadeIn {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }

      .startup-spinner-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2rem;
      }

      .spinner {
        width: 60px;
        height: 60px;
        border: 4px solid rgba(255, 255, 255, 0.2);
        border-top: 4px solid white;
        border-radius: 50%;
        animation: spin 1s linear infinite;
      }

      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }

      .startup-message {
        color: white;
        font-size: 1.125rem;
        font-weight: 500;
        margin: 0;
        letter-spacing: 0.5px;
        animation: pulse 2s ease-in-out infinite;
      }

      @keyframes pulse {
        0%,
        100% {
          opacity: 0.8;
        }
        50% {
          opacity: 1;
        }
      }
    `,
  ],
})
export class StartupLoadingOverlayComponent {
  private authService = inject(AuthService);

  // Computed property to check if we're in startup loading state
  isStartupLoading = computed(() => {
    return this.authService.isStartupLoading();
  });
}
